<template>
    <div>
        <div class="modal-card" style="width: auto" v-on:keydown.enter="login">
            <header class="modal-card-head">
                <p class="modal-card-title">Login</p>
            </header>
            <section class="modal-card-body">
                <b-field label="Email">
                    <b-input
                            type="email"
                            placeholder="Your email"
                            required v-model="username">
                    </b-input>
                </b-field>

                <b-field label="Password">
                    <b-input
                            type="password"
                            password-reveal
                            placeholder="Your password"
                            required v-model="password" >
                    </b-input>
                </b-field>

                <p v-if="error">{{error}}</p>

            </section>
            <footer class="modal-card-foot">
                <button class="button is-primary" v-on:click="login">Login</button>
            </footer>
        </div>
    </div>
</template>
<script>
export default {
  name: 'login',
  data () {
    return {
      username: null,
      password: null,
      error: null
    }
  },
  methods: {
    login: function () {
      console.log('login')
      const app = this
      this.$http.post(process.env.BASE_URL + 'oauth/token', {
        grant_type: 'password',
        client_id: process.env.CLIENT_ID,
        client_secret: process.env.CLIENT_SECRET,
        username: this.username,
        password: this.password,
        scope: ''
      }).then(function (response) {
        localStorage.setItem('accessToken', response.data.access_token)
        app.$store.commit('authenticated', true)
        app.$router.go()
      }).catch(function (error) {
        console.log(error.response.data)
        app.error = error.response.data.message
      })
    }
  }
}
</script>
